import React, {FC} from 'react';
import classes from './container.module.sass';

interface ContainerProps {
    children: React.ReactNode;
    className?: string;
    style?: any
}

const Container: FC<ContainerProps> = (
    {children, className, style}
) => {
    return (
        <section style={style} className={classes.container + ' ' + className}>
            {children}
        </section>
    );
};

export default Container;